import { ReactElement } from 'react'
import styled from 'styled-components'

import { IIconProps } from './types'

const Svg = styled.svg`
  fill: #423f9a;
  height: 24px;
  width: 24px;
`

export const TripsIcon = ({ className }: IIconProps): ReactElement => {
  return (
    <Svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.2992 8.4H14.3992V5.7C14.3992 5.1 13.8992 4.5 13.1992 4.5H10.8992C10.2992 4.5 9.69922 5 9.69922 5.7V8.4H8.69922C8.09922 8.4 7.69922 8.9 7.69922 9.4V17.7C7.69922 18.3 8.19922 18.7 8.69922 18.7H9.79922V19.1C9.79922 19.2 9.89922 19.3 9.99922 19.3H10.1992C10.2992 19.3 10.3992 19.2 10.3992 19.1V18.7H13.3992V19.1C13.3992 19.2 13.4992 19.3 13.5992 19.3H13.9992C14.0992 19.3 14.1992 19.2 14.1992 19.1V18.7H15.1992C15.7992 18.7 16.1992 18.2 16.1992 17.7V9.5C16.2992 8.9 15.7992 8.4 15.2992 8.4ZM10.7992 5.7C10.7992 5.6 10.8992 5.5 10.9992 5.5H13.2992C13.3992 5.5 13.4992 5.6 13.4992 5.7V8.4H10.8992V5.7H10.7992ZM11.2992 15.4C11.2992 15.6 11.0992 15.8 10.8992 15.8C10.6992 15.8 10.4992 15.6 10.4992 15.4V11.7C10.4992 11.5 10.6992 11.3 10.8992 11.3C11.0992 11.3 11.2992 11.5 11.2992 11.7V15.4ZM13.4992 15.4C13.4992 15.6 13.2992 15.8 13.0992 15.8C12.8992 15.8 12.6992 15.6 12.6992 15.4V11.7C12.6992 11.5 12.8992 11.3 13.0992 11.3C13.2992 11.3 13.4992 11.5 13.4992 11.7V15.4Z" />
    </Svg>
  )
}
